<div class="mapContainer">
  <div id="{{target}}" class="map"></div>
  <app-layer-switcher 
    [collapsible]="true"
    [baseLayers]="itemLayers" 
    (activate)="activateItem($event)"
    [maxHeight]="200">
  </app-layer-switcher>
  <div id="popup-disponibilidad" class="ol-popup">
    <span id="popup-diponibilidad-closer" class="ol-popup-closer" (click)="closePopUp()"></span>
    <div id="popup-disponibilidad-content"></div>
  </div>
</div>
